import { WorkspaceAction } from '@sales-app/context/workspace/workspace.actions'
import { useWorkspaceContext } from '@sales-app/context/workspace/workspace.hooks'
import { Form, Formik } from 'formik'
import React, { FC } from 'react'

import { InputSelect } from '@/components'

type Props = {
  reservationType?: string
}

export enum ReservationType {
  Flexible = 'Flexible',
  Standard = 'Standard',
  Standby = 'Standby',
}

export const ReservationTypeSelection: FC<Props> = ({ reservationType }) => {
  const [, WorkspaceDispatch] = useWorkspaceContext()
  const typeOptions = [
    { label: 'Select Type', value: '' },
    { label: 'Flexible', value: ReservationType.Flexible },
    { label: 'Standby', value: ReservationType.Standby },
    { label: 'Standard', value: ReservationType.Standard },
  ]

  const onChange = (values: { reservationType: string }) => {
    const { reservationType = '' } = values
    if (reservationType === ReservationType.Flexible || reservationType === ReservationType.Standby) {
      WorkspaceDispatch(
        WorkspaceAction.updateFilters({
          reservationType: values.reservationType,
          moveOutStartDate: undefined,
          moveOutEndDate: undefined,
        }),
      )
    } else {
      WorkspaceDispatch(WorkspaceAction.updateFilters({ reservationType: values.reservationType }))
    }
  }

  return (
    <Formik
      initialValues={{
        reservationType: reservationType,
      }}
      onSubmit={onChange}
    >
      {({ submitForm }) => {
        return (
          <Form className="flex w-1/2 flex-row flex-wrap">
            <InputSelect
              className="w-full"
              id="reservationType"
              name="reservationType"
              onChange={submitForm}
              options={typeOptions}
              overviewDropdown={true}
            ></InputSelect>
          </Form>
        )
      }}
    </Formik>
  )
}
